/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { Toggle } from '@pointfive/ui';
import type { ViewModel } from './view-model';

export function TradingIdentityView({ m }: { m: ViewModel }) {
  return (
    <div style={{ padding: '24px 12px 40px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {' '}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px', flexWrap: 'wrap' }}>
        {' '}
        <div style={{ flex: '1', minWidth: '260px' }}>
          {' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
            <i className="ph ph-fingerprint" style={{ fontSize: '17px', color: 'var(--acc)' }}></i>
            <span style={{ fontSize: '15px', fontWeight: '600', letterSpacing: '-0.01em' }}>
              Trading Identity
            </span>
          </div>{' '}
          <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '4px', maxWidth: '80ch' }}>
            Your identity governs how the AI coach reads your performance. A scalper's 40 trades in a session
            is consistency — not overtrading.
          </div>{' '}
        </div>{' '}
        <div style={{ display: 'flex', gap: '8px', flex: 'none', alignItems: 'center' }}>
          {' '}
          <button
            className="scp-4f3e86a"
            onClick={m.tiDetect}
            aria-label="Auto-detect style from history"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '7px',
              fontSize: '11px',
              padding: '7px 13px',
              borderRadius: '99px',
              border: '1px solid var(--l10)',
              background: 'transparent',
              color: 'var(--text-mid)',
              cursor: 'pointer',
            }}
          >
            <i className="ph ph-arrows-clockwise" style={{ fontSize: '13px' }}></i>Auto-detect
          </button>{' '}
          <button
            className="scp-6741c2e"
            onClick={m.tiSave}
            aria-label="Save trading identity"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '7px',
              fontSize: '11.5px',
              fontWeight: '600',
              padding: '7px 15px',
              borderRadius: '99px',
              border: '1px solid color-mix(in srgb, var(--acc-fill) 45%, transparent)',
              background: 'color-mix(in srgb, var(--acc-fill) 12%, transparent)',
              color: 'var(--acc)',
              cursor: 'pointer',
            }}
          >
            <i className="ph ph-check-circle" style={{ fontSize: '14px' }}></i>Save profile
          </button>{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '16px 18px 14px',
          display: 'flex',
          alignItems: 'flex-start',
          gap: '14px',
          flexWrap: 'wrap',
        }}
      >
        {' '}
        <span
          style={dc.css(
            `width:38px;height:38px;border-radius:9px;background:var(--l6);color:${dc.s(m.tiColour)};display:flex;align-items:center;justify-content:center;flex:none`,
          )}
        >
          <i className={`ph ${dc.s(m.tiIcon)}`} style={{ fontSize: '18px' }}></i>
        </span>{' '}
        <div style={{ flex: '1', minWidth: '240px' }}>
          {' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            {' '}
            <span style={{ fontSize: '13.5px', fontWeight: '600' }}>{dc.t(m.tiLabel)}</span>{' '}
            <span
              style={{
                fontSize: '9.5px',
                fontWeight: '600',
                letterSpacing: '0.05em',
                padding: '3px 9px',
                borderRadius: '99px',
                background: 'var(--l6)',
                color: 'var(--text-mid)',
              }}
            >
              {dc.t(m.tiExpLabel)}
            </span>{' '}
            {m.tiHasDetected ? (
              <>
                {' '}
                <span
                  style={{
                    fontSize: '9.5px',
                    padding: '3px 9px',
                    borderRadius: '99px',
                    border: '1px solid var(--l10)',
                    color: 'var(--muted)',
                  }}
                >
                  {'Auto-detected: '}
                  {dc.t(m.tiDetectedLabel)}
                </span>{' '}
              </>
            ) : null}{' '}
          </div>{' '}
          <div
            style={{
              fontSize: '11.5px',
              color: 'var(--muted)',
              lineHeight: '1.6',
              marginTop: '5px',
              maxWidth: '82ch',
            }}
          >
            {dc.t(m.tiDescription)}
          </div>{' '}
          {m.tiHasDetected ? (
            <>
              {' '}
              <div
                style={{
                  fontSize: '10.5px',
                  color: 'var(--muted2)',
                  marginTop: '7px',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {'Read from '}
                {dc.t(m.tiSampleN)}
                {' — median hold '}
                {dc.t(m.tiMedianHold)}
                {', '}
                {dc.t(m.tiPerDay)}
                {' per active day.'}
              </div>{' '}
            </>
          ) : null}{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,170px),1fr))',
          gap: '12px',
        }}
      >
        {' '}
        {(m.tiFacts ?? []).map((f, i204) => (
          <Fragment key={i204}>
            {' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '13px 15px',
              }}
            >
              {' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <i className={`ph ${dc.s(f?.icon)}`} style={{ fontSize: '12px', color: 'var(--muted2)' }}></i>
                <span
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  {dc.t(f?.label)}
                </span>
              </div>{' '}
              <div
                style={dc.css(
                  `font-size:13.5px;font-weight:600;letter-spacing:-0.01em;font-variant-numeric:tabular-nums;margin-top:6px;color:${dc.s(f?.fg)}`,
                )}
              >
                {dc.t(f?.value)}
              </div>{' '}
            </div>{' '}
          </Fragment>
        ))}{' '}
      </div>{' '}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,400px),1fr))',
          gap: '12px',
          alignItems: 'start',
        }}
      >
        {' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '16px 18px 14px',
          }}
        >
          {' '}
          <div
            style={{
              fontSize: '9.5px',
              letterSpacing: '0.13em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Step 1 · Primary style
          </div>{' '}
          <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '5px' }}>
            Which best describes how you trade?
          </div>{' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '12px' }}>
            {' '}
            {(m.tiStyles ?? []).map((s, i205) => (
              <Fragment key={i205}>
                {' '}
                <button
                  className="scp-4f3e86a"
                  onClick={s?.go}
                  aria-pressed={dc.b(s?.on)}
                  aria-label={dc.a(s?.label)}
                  style={dc.css(
                    `display:flex;align-items:flex-start;gap:11px;width:100%;text-align:left;padding:10px 12px;border-radius:11px;border:1px solid ${dc.s(s?.bd)};background:${dc.s(s?.bg)};cursor:pointer`,
                  )}
                >
                  {' '}
                  <span
                    style={dc.css(
                      `width:28px;height:28px;border-radius:9px;background:var(--l6);color:${dc.s(s?.iconFg)};display:flex;align-items:center;justify-content:center;flex:none`,
                    )}
                  >
                    <i className={`ph ${dc.s(s?.icon)}`} style={{ fontSize: '15px' }}></i>
                  </span>{' '}
                  <span style={{ flex: '1', minWidth: '0' }}>
                    {' '}
                    <span style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                      <span style={dc.css(`font-size:12.5px;font-weight:${dc.s(s?.fw)};color:var(--text)`)}>
                        {dc.t(s?.label)}
                      </span>
                      {s?.on ? (
                        <i
                          className="ph-fill ph-check-circle"
                          style={{ fontSize: '13px', color: 'var(--acc)' }}
                        ></i>
                      ) : null}
                    </span>{' '}
                    <span
                      style={{
                        display: 'block',
                        fontSize: '10.5px',
                        color: 'var(--muted2)',
                        marginTop: '2px',
                      }}
                    >
                      {dc.t(s?.subtitle)}
                    </span>{' '}
                  </span>{' '}
                  <span
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '3px',
                      alignItems: 'flex-end',
                      flex: 'none',
                    }}
                  >
                    {' '}
                    <span
                      style={{
                        fontSize: '9px',
                        padding: '2px 8px',
                        borderRadius: '99px',
                        background: 'var(--l6)',
                        color: 'var(--text-mid)',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {dc.t(s?.holdTime)}
                    </span>{' '}
                    <span
                      style={{
                        fontSize: '9px',
                        padding: '2px 8px',
                        borderRadius: '99px',
                        border: '1px solid var(--l8)',
                        color: 'var(--muted2)',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {dc.t(s?.tradeFreq)}
                    </span>{' '}
                  </span>{' '}
                </button>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
        </div>{' '}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px 14px',
            }}
          >
            {' '}
            <div
              style={{
                fontSize: '9.5px',
                letterSpacing: '0.13em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
              }}
            >
              Step 2 · Experience
            </div>{' '}
            <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '5px' }}>
              How long have you been actively trading?
            </div>{' '}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '12px' }}>
              {' '}
              {(m.tiExps ?? []).map((e, i206) => (
                <Fragment key={i206}>
                  {' '}
                  <button
                    className="scp-4f3e86a"
                    onClick={e?.go}
                    aria-pressed={dc.b(e?.on)}
                    aria-label={dc.a(e?.label)}
                    style={dc.css(
                      `display:flex;align-items:center;gap:10px;width:100%;text-align:left;padding:9px 12px;border-radius:11px;border:1px solid ${dc.s(e?.bd)};background:${dc.s(e?.bg)};cursor:pointer`,
                    )}
                  >
                    {' '}
                    <span style={{ flex: '1', minWidth: '0' }}>
                      {' '}
                      <span style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                        <span style={dc.css(`font-size:12.5px;font-weight:${dc.s(e?.fw)};color:var(--text)`)}>
                          {dc.t(e?.label)}
                        </span>
                        {e?.on ? (
                          <i
                            className="ph-fill ph-check-circle"
                            style={{ fontSize: '13px', color: 'var(--acc)' }}
                          ></i>
                        ) : null}
                      </span>{' '}
                      <span
                        style={{
                          display: 'block',
                          fontSize: '10.5px',
                          color: 'var(--muted2)',
                          marginTop: '2px',
                        }}
                      >
                        {dc.t(e?.desc)}
                      </span>{' '}
                    </span>{' '}
                  </button>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </div>{' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px 14px',
            }}
          >
            {' '}
            <div
              style={{
                fontSize: '9.5px',
                letterSpacing: '0.13em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
              }}
            >
              Step 3 · Risk rules
            </div>{' '}
            <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '5px' }}>
              Your personal norms — the benchmark every AI insight is measured against, not hard blocks.
            </div>{' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,140px),1fr))',
                gap: '12px',
                marginTop: '13px',
              }}
            >
              {' '}
              <div>
                {' '}
                <label
                  style={{
                    display: 'block',
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Max trades / day
                </label>{' '}
                <input
                  type="number"
                  min="1"
                  max="200"
                  value={dc.v(m.tiMax)}
                  onChange={m.tiSetMax}
                  placeholder={dc.a(m.tiMaxHint)}
                  aria-label="Max trades per day"
                  style={{
                    width: '100%',
                    boxSizing: 'border-box',
                    marginTop: '6px',
                    height: '34px',
                    padding: '0 11px',
                    borderRadius: '11px',
                    border: '1px solid var(--l8)',
                    background: 'var(--l3)',
                    color: 'var(--text)',
                    fontSize: '12.5px',
                    fontFamily: 'inherit',
                    fontVariantNumeric: 'tabular-nums',
                    outline: 'none',
                  }}
                />{' '}
              </div>{' '}
              <div>
                {' '}
                <label
                  style={{
                    display: 'block',
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Target R:R
                </label>{' '}
                <input
                  type="text"
                  value={dc.v(m.tiRR)}
                  onChange={m.tiSetRR}
                  placeholder="e.g. 1:2"
                  aria-label="Target risk to reward ratio"
                  style={{
                    width: '100%',
                    boxSizing: 'border-box',
                    marginTop: '6px',
                    height: '34px',
                    padding: '0 11px',
                    borderRadius: '11px',
                    border: '1px solid var(--l8)',
                    background: 'var(--l3)',
                    color: 'var(--text)',
                    fontSize: '12.5px',
                    fontFamily: 'inherit',
                    fontVariantNumeric: 'tabular-nums',
                    outline: 'none',
                  }}
                />{' '}
              </div>{' '}
              <div>
                {' '}
                <label
                  style={{
                    display: 'block',
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Risk / trade (%)
                </label>{' '}
                <input
                  type="text"
                  value={dc.v(m.tiRisk)}
                  onChange={m.tiSetRisk}
                  placeholder="e.g. 1"
                  aria-label="Risk per trade percent"
                  style={{
                    width: '100%',
                    boxSizing: 'border-box',
                    marginTop: '6px',
                    height: '34px',
                    padding: '0 11px',
                    borderRadius: '11px',
                    border: '1px solid var(--l8)',
                    background: 'var(--l3)',
                    color: 'var(--text)',
                    fontSize: '12.5px',
                    fontFamily: 'inherit',
                    fontVariantNumeric: 'tabular-nums',
                    outline: 'none',
                  }}
                />{' '}
              </div>{' '}
            </div>{' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '8px',
                marginTop: '12px',
                paddingTop: '9px',
                borderTop: '1px solid var(--l6)',
              }}
            >
              {' '}
              <i
                className="ph ph-info"
                style={{ fontSize: '13px', color: 'var(--muted2)', flex: 'none', marginTop: '1px' }}
              ></i>{' '}
              <div style={{ fontSize: '10.5px', color: 'var(--muted2)', lineHeight: '1.55' }}>
                {dc.t(m.tiRuleNote)}
              </div>{' '}
            </div>{' '}
            {m.tiIsCustom ? (
              <>
                {' '}
                <div style={{ marginTop: '12px' }}>
                  {' '}
                  <label
                    style={{
                      display: 'block',
                      fontSize: '9px',
                      letterSpacing: '0.11em',
                      textTransform: 'uppercase',
                      color: 'var(--muted2)',
                      fontWeight: '600',
                    }}
                  >
                    Describe your style
                  </label>{' '}
                  <textarea
                    rows={3}
                    value={dc.v(m.tiDesc)}
                    onChange={m.tiSetDesc}
                    placeholder="e.g. I scalp the London open and swing the dailies…"
                    aria-label="Style description"
                    style={{
                      width: '100%',
                      boxSizing: 'border-box',
                      marginTop: '6px',
                      padding: '9px 11px',
                      borderRadius: '11px',
                      border: '1px solid var(--l8)',
                      background: 'var(--l3)',
                      color: 'var(--text)',
                      fontSize: '12px',
                      fontFamily: 'inherit',
                      lineHeight: '1.55',
                      resize: 'vertical',
                      outline: 'none',
                    }}
                  ></textarea>{' '}
                </div>{' '}
              </>
            ) : null}{' '}
          </div>{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '16px 18px 14px',
        }}
      >
        {' '}
        <div
          style={{
            fontSize: '9.5px',
            letterSpacing: '0.13em',
            textTransform: 'uppercase',
            color: 'var(--muted2)',
            fontWeight: '600',
          }}
        >
          Step 4 · Sessions & markets
        </div>{' '}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,300px),1fr))',
            gap: '16px',
            marginTop: '12px',
          }}
        >
          {' '}
          <div>
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <i
                className="ph ph-globe-hemisphere-west"
                style={{ fontSize: '13px', color: 'var(--muted2)' }}
              ></i>
              <span style={{ fontSize: '11.5px', fontWeight: '500' }}>Preferred sessions</span>
              <span style={{ fontSize: '10px', color: 'var(--muted2)' }}>
                {'· '}
                {dc.t(m.tiSessCount)}
              </span>
            </div>{' '}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '7px', marginTop: '10px' }}>
              {' '}
              {(m.tiSessions ?? []).map((s, i207) => (
                <Fragment key={i207}>
                  {' '}
                  <button
                    className="scp-4f3e86a"
                    onClick={s?.go}
                    aria-pressed={dc.b(s?.on)}
                    aria-label={dc.a(s?.label)}
                    style={dc.css(
                      `font-size:11px;font-weight:${dc.s(s?.fw)};padding:5px 12px;border-radius:99px;border:1px solid ${dc.s(s?.bd)};background:${dc.s(s?.bg)};color:${dc.s(s?.fg)};cursor:pointer`,
                    )}
                  >
                    {dc.t(s?.label)}
                  </button>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </div>{' '}
          <div>
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <i className="ph ph-chart-bar" style={{ fontSize: '13px', color: 'var(--muted2)' }}></i>
              <span style={{ fontSize: '11.5px', fontWeight: '500' }}>Primary instruments</span>
              <span style={{ fontSize: '10px', color: 'var(--muted2)' }}>
                {'· '}
                {dc.t(m.tiInstCount)}
              </span>
            </div>{' '}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '7px', marginTop: '10px' }}>
              {' '}
              {(m.tiInstruments ?? []).map((i, i208) => (
                <Fragment key={i208}>
                  {' '}
                  <button
                    className="scp-4f3e86a"
                    onClick={i?.go}
                    aria-pressed={dc.b(i?.on)}
                    aria-label={dc.a(i?.label)}
                    style={dc.css(
                      `font-size:11px;font-weight:${dc.s(i?.fw)};padding:5px 12px;border-radius:99px;border:1px solid ${dc.s(i?.bd)};background:${dc.s(i?.bg)};color:${dc.s(i?.fg)};cursor:pointer`,
                    )}
                  >
                    {dc.t(i?.label)}
                  </button>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </div>{' '}
        </div>{' '}
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '8px',
            marginTop: '13px',
            paddingTop: '9px',
            borderTop: '1px solid var(--l6)',
          }}
        >
          {' '}
          <i
            className="ph ph-target"
            style={{ fontSize: '13px', color: 'var(--muted2)', flex: 'none', marginTop: '1px' }}
          ></i>{' '}
          <div style={{ fontSize: '10.5px', color: 'var(--muted2)', lineHeight: '1.55' }}>
            {dc.t(m.tiCoverageNote)}
          </div>{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '16px 18px 14px',
        }}
      >
        {' '}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', flexWrap: 'wrap' }}>
          {' '}
          <div style={{ flex: '1', minWidth: '240px' }}>
            {' '}
            <div
              style={{
                fontSize: '9.5px',
                letterSpacing: '0.13em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
              }}
            >
              Step 5 · Trading rules
            </div>{' '}
            <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '5px' }}>
              Shown in the Rules Review before each session. Toggle, reorder, rename or add your own — system
              rules can be disabled but not deleted.
            </div>{' '}
          </div>{' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 'none' }}>
            {' '}
            <span
              style={{
                fontSize: '9.5px',
                fontWeight: '600',
                letterSpacing: '0.05em',
                padding: '4px 10px',
                borderRadius: '99px',
                background: 'var(--l6)',
                color: 'var(--text-mid)',
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {dc.t(m.tiRuleCount)}
            </span>{' '}
            <button
              className="scp-4f3e86a"
              onClick={m.tiRulesRestore}
              aria-label="Restore platform defaults"
              title="Restore platform defaults"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '11px',
                padding: '6px 12px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                background: 'transparent',
                color: 'var(--text-mid)',
                cursor: 'pointer',
              }}
            >
              <i className="ph ph-arrow-counter-clockwise" style={{ fontSize: '12px' }}></i>Restore defaults
            </button>{' '}
          </div>{' '}
        </div>{' '}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '13px' }}>
          {' '}
          {(m.tiRules ?? []).map((r, i209) => (
            <Fragment key={i209}>
              {' '}
              <div
                style={dc.css(
                  `display:flex;align-items:center;gap:10px;padding:8px 11px;border-radius:11px;border:1px solid var(--l8);background:var(--l3);opacity:${dc.s(r?.op)}`,
                )}
              >
                {' '}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1px', flex: 'none' }}>
                  {' '}
                  <button
                    className="scp-e5d0807"
                    onClick={r?.up}
                    aria-label="Move up"
                    title="Move up"
                    style={{
                      width: '16px',
                      height: '13px',
                      padding: '0',
                      border: 'none',
                      background: 'transparent',
                      color: 'var(--faint)',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <i className="ph ph-caret-up" style={{ fontSize: '10px' }}></i>
                  </button>{' '}
                  <button
                    className="scp-e5d0807"
                    onClick={r?.down}
                    aria-label="Move down"
                    title="Move down"
                    style={{
                      width: '16px',
                      height: '13px',
                      padding: '0',
                      border: 'none',
                      background: 'transparent',
                      color: 'var(--faint)',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <i className="ph ph-caret-down" style={{ fontSize: '10px' }}></i>
                  </button>{' '}
                </div>{' '}
                <Toggle
                  trackBg={r?.trackBg}
                  knobBg={r?.knobBg}
                  knob={r?.knob}
                  onClick={r?.toggle}
                  aria-label={dc.s(r?.toggleLabel)}
                  aria-pressed={dc.b(r?.on)}
                />{' '}
                {r?.editing ? (
                  <>
                    {' '}
                    <input
                      value={dc.v(m.tiRuleDraft)}
                      onChange={m.tiSetRuleDraft}
                      aria-label="Rule text"
                      style={{
                        flex: '1',
                        minWidth: '0',
                        height: '30px',
                        padding: '0 10px',
                        borderRadius: '9px',
                        border: '1px solid color-mix(in srgb, var(--acc-fill) 45%, transparent)',
                        background: 'var(--surface)',
                        color: 'var(--text)',
                        fontSize: '12px',
                        fontFamily: 'inherit',
                        outline: 'none',
                      }}
                    />{' '}
                    <button
                      className="scp-4f3e86a"
                      onClick={m.tiRuleCommit}
                      aria-label="Save rule"
                      style={{
                        width: '26px',
                        height: '26px',
                        flex: 'none',
                        borderRadius: '9px',
                        border: '1px solid var(--l8)',
                        background: 'transparent',
                        color: 'var(--pos)',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <i className="ph ph-check" style={{ fontSize: '13px' }}></i>
                    </button>{' '}
                    <button
                      className="scp-4f3e86a"
                      onClick={m.tiRuleCancel}
                      aria-label="Cancel edit"
                      style={{
                        width: '26px',
                        height: '26px',
                        flex: 'none',
                        borderRadius: '9px',
                        border: '1px solid var(--l8)',
                        background: 'transparent',
                        color: 'var(--muted)',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <i className="ph ph-x" style={{ fontSize: '13px' }}></i>
                    </button>{' '}
                  </>
                ) : null}{' '}
                {r?.reading ? (
                  <>
                    {' '}
                    <span
                      style={dc.css(
                        `flex:1;min-width:0;font-size:12px;color:${dc.s(r?.fg)};text-decoration:${dc.s(r?.deco)};line-height:1.45`,
                      )}
                    >
                      {dc.t(r?.text)}
                    </span>{' '}
                    {r?.sys ? (
                      <>
                        {' '}
                        <span
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                            fontSize: '9px',
                            padding: '2px 8px',
                            borderRadius: '99px',
                            border: '1px solid var(--l8)',
                            color: 'var(--muted2)',
                            flex: 'none',
                          }}
                        >
                          <i className="ph ph-lock-simple" style={{ fontSize: '9px' }}></i>System
                        </span>{' '}
                      </>
                    ) : null}{' '}
                    {r?.own ? (
                      <>
                        {' '}
                        <button
                          className="scp-4f3e86a"
                          onClick={r?.edit}
                          aria-label="Edit rule"
                          title="Edit rule"
                          style={{
                            width: '26px',
                            height: '26px',
                            flex: 'none',
                            borderRadius: '9px',
                            border: '1px solid var(--l8)',
                            background: 'transparent',
                            color: 'var(--muted)',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <i className="ph ph-pencil-simple" style={{ fontSize: '12px' }}></i>
                        </button>{' '}
                        <button
                          className="scp-4bed646"
                          onClick={r?.remove}
                          aria-label="Delete rule"
                          title="Delete rule"
                          style={{
                            width: '26px',
                            height: '26px',
                            flex: 'none',
                            borderRadius: '9px',
                            border: '1px solid var(--l8)',
                            background: 'transparent',
                            color: 'var(--muted)',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <i className="ph ph-trash" style={{ fontSize: '12px' }}></i>
                        </button>{' '}
                      </>
                    ) : null}{' '}
                  </>
                ) : null}{' '}
              </div>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '11px' }}>
          {' '}
          <input
            value={dc.v(m.tiRuleNew)}
            onChange={m.tiSetRuleNew}
            placeholder="Add your own rule…"
            aria-label="New rule"
            style={{
              flex: '1',
              minWidth: '0',
              height: '34px',
              padding: '0 12px',
              borderRadius: '11px',
              border: '1px solid var(--l8)',
              background: 'var(--l3)',
              color: 'var(--text)',
              fontSize: '12px',
              fontFamily: 'inherit',
              outline: 'none',
            }}
          />{' '}
          <button
            className="scp-4f3e86a"
            onClick={m.tiRuleAdd}
            aria-label="Add rule"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '11.5px',
              fontWeight: '500',
              padding: '8px 14px',
              borderRadius: '99px',
              border: '1px solid var(--l10)',
              background: 'transparent',
              color: 'var(--text-mid)',
              cursor: 'pointer',
              flex: 'none',
            }}
          >
            <i className="ph ph-plus" style={{ fontSize: '12px' }}></i>Add rule
          </button>{' '}
        </div>{' '}
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '8px',
            marginTop: '12px',
            paddingTop: '9px',
            borderTop: '1px solid var(--l6)',
          }}
        >
          {' '}
          <i
            className="ph ph-checks"
            style={{ fontSize: '13px', color: 'var(--muted2)', flex: 'none', marginTop: '1px' }}
          ></i>{' '}
          <div style={{ fontSize: '10.5px', color: 'var(--muted2)', lineHeight: '1.55' }}>
            {dc.t(m.tiRuleFootnote)}
          </div>{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,340px),1fr))',
          gap: '12px',
          alignItems: 'start',
        }}
      >
        {' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '16px 18px 14px',
          }}
        >
          {' '}
          <div
            style={{
              fontSize: '9.5px',
              letterSpacing: '0.13em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Step 6 · Goals
          </div>{' '}
          <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '5px' }}>
            Every recommendation is framed around these.
          </div>{' '}
          <textarea
            rows={5}
            value={dc.v(m.tiGoals)}
            onChange={m.tiSetGoals}
            placeholder="e.g. Grow from $10k to $50k over 12 months with max drawdown under 5%…"
            aria-label="Trading goals"
            style={{
              width: '100%',
              boxSizing: 'border-box',
              marginTop: '11px',
              padding: '10px 12px',
              borderRadius: '11px',
              border: '1px solid var(--l8)',
              background: 'var(--l3)',
              color: 'var(--text)',
              fontSize: '12px',
              fontFamily: 'inherit',
              lineHeight: '1.6',
              resize: 'vertical',
              outline: 'none',
            }}
          ></textarea>{' '}
          <div style={{ fontSize: '9.5px', color: 'var(--faint)', marginTop: '7px' }}>
            {dc.t(m.tiGoalWords)}
          </div>{' '}
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid color-mix(in srgb, var(--acc-fill) 30%, transparent)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '16px 18px 14px',
          }}
        >
          {' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
            <i className="ph-fill ph-sparkle" style={{ fontSize: '14px', color: 'var(--acc)' }}></i>
            <span style={{ fontSize: '12px', fontWeight: '600', color: 'var(--acc)' }}>
              What this changes
            </span>
          </div>{' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '9px', marginTop: '11px' }}>
            {' '}
            {(m.tiEffects ?? []).map((e, i210) => (
              <Fragment key={i210}>
                {' '}
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '9px' }}>
                  {' '}
                  <i
                    className={`ph ${dc.s(e?.icon)}`}
                    style={dc.css(`font-size:13px;color:${dc.s(e?.fg)};flex:none;margin-top:2px`)}
                  ></i>{' '}
                  <div style={{ flex: '1', minWidth: '0' }}>
                    <div style={{ fontSize: '11.5px', fontWeight: '500' }}>{dc.t(e?.title)}</div>
                    <div
                      style={{
                        fontSize: '10.5px',
                        color: 'var(--muted2)',
                        lineHeight: '1.55',
                        marginTop: '2px',
                      }}
                    >
                      {dc.t(e?.body)}
                    </div>
                  </div>{' '}
                </div>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
          <div
            style={{
              fontSize: '10px',
              color: 'var(--faint)',
              marginTop: '12px',
              paddingTop: '9px',
              borderTop: '1px solid var(--l6)',
            }}
          >
            {dc.t(m.tiSavedNote)}
          </div>{' '}
        </div>{' '}
      </div>
    </div>
  );
}
